import Store from "../../../../Store/Store";

class ReadinessStatusContainer {
  public pickIdFromLabel(label) {
    const readinessStatuses = Store.getConfigurator().getState().globalTypes?.ReadinessStatus;
    for(const key in readinessStatuses) {
      if (readinessStatuses?.[key]?.label?.toLowerCase() === label?.toLowerCase()) {
        return readinessStatuses?.[key]?.id
      }
    }
  }
}

export default new ReadinessStatusContainer();
